import { useSelector } from 'hooks/utils';
import { selectAreFiltersValid } from 'store/data/filters';

export function useAreFiltersValid() {
	return useSelector(state => selectAreFiltersValid(state.data.filters));
}
